const PERSON_NAME_FIELDS = new Set([
  "first_name",
  "middle_name",
  "last_name",
  "full_name",
  "partner_name",
  "contact_person_name",
  "referral_name",
]);

const LABEL_NAME_FIELDS = new Set([
  "company_name",
  "institution_name",
  "degree_name",
  "education_description",
  "occupation_details",
  "work_profile",
  "contact_person_relation",
  "relation_type",
  "sakha_name",
]);

function capitalizeWord(word, lowercaseRest) {
  if (!word) return word;
  const [first = "", ...rest] = Array.from(word);
  return `${first.toLocaleUpperCase()}${lowercaseRest ? rest.join("").toLocaleLowerCase() : rest.join("")}`;
}

function capitalizeWords(value, lowercaseRest) {
  return String(value).replace(/\p{L}+/gu, (word) => capitalizeWord(word, lowercaseRest));
}

export function normalizeNameInputValue(field, value) {
  if (typeof value !== "string") return value;

  const normalizedField = String(field || "").trim();
  if (PERSON_NAME_FIELDS.has(normalizedField)) {
    return capitalizeWords(value, true);
  }

  if (LABEL_NAME_FIELDS.has(normalizedField)) {
    return capitalizeWords(value, false);
  }

  return value;
}

export function normalizeNameFieldsInRecord(value) {
  if (Array.isArray(value)) {
    return value.map((item) => normalizeNameFieldsInRecord(item));
  }

  if (!value || typeof value !== "object") {
    return value;
  }

  return Object.entries(value).reduce((next, [key, entryValue]) => {
    next[key] =
      typeof entryValue === "string"
        ? normalizeNameInputValue(key, entryValue)
        : normalizeNameFieldsInRecord(entryValue);
    return next;
  }, {});
}
